export default "__VITE_ASSET__BcqOveim__"